import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { Modal } from "react-bootstrap";
import http from "../../../Common/http-common";
import * as common from "../../../Common/common";
import * as Comp from "../../../Common/CommonComponents";
import BackModal from '../../../Components/BasicElements/BackModal';
import ConfirmModal from '../../../Components/BasicElements/ConfirmModal';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const LeaveApprove = (props) => {
	const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [username] = useState(cookies.USERNAME);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading....");
	const [userListToBeSelect, setUserListToBeSelect] = useState([]);
  const [userList, setUserList] = useState([]);
  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

	useEffect(() => {
    if (props.editData !== null) {
      setEditData({
				LEAVE_MST_ID: props.editData.LEAVE_MST_ID === null ? "" : props.editData.LEAVE_MST_ID,
        USER_MST_GUID: props.editData.USER_MST_GUID === null ? "" : props.editData.USER_MST_GUID,
				USERNAME: props.editData.USERNAME === null ? "" : props.editData.USERNAME,
        STATUS: props.editData.STATUS === null ? "" : props.editData.STATUS,
        LEAVE_TYPE: props.editData.LEAVE_TYPE === null ? "" : props.editData.LEAVE_TYPE,
        LEAVE_SESSION: props.editData.LEAVE_SESSION === null ? "" : props.editData.LEAVE_SESSION,
        REASON: props.editData.REASON === null ? "" : props.editData.REASON,
        SUBMIT_NAME: props.editData.SUBMIT_NAME === null ? "" : props.editData.SUBMIT_NAME,
      })
    }
  }, [props.editData]);

	function SaveApproveLeave() {
    if (userList.length !== 0) {
      let functionName = "";
      try {
        functionName = SaveApproveLeave.name;
        props.onLoading(true, "Approving this leave, please wait...");
        const selectedUserList = userList.map(r => r.key).join(',');
        const data = {
          LEAVE_MST_ID: editData.LEAVE_MST_ID,
          USER_MST_GUID: editData.USER_MST_GUID,
          USERNAME: editData.USERNAME,
          LEAVE_TYPE: editData.LEAVE_TYPE,
          LEAVE_SESSION: editData.LEAVE_SESSION,
          REASON: editData.REASON,
          COVER_ID: selectedUserList,
          SUBMIT_NAME: editData.SUBMIT_NAME,
          UPDATE_ID: userId,
          UPDATE_NAME: username,
          FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
        };

        http
          .post("api/leaveHistory/ApproveLeave", data, { timeout: 5000 })
          .then((response) => {
            toast.success("Leave application is successfully approved.");
            props.onReload();
          })
          .catch((err) => {
            const errorData = err.response?.data || {};
            if (errorData.VALID === "INSUFFICIENT_BALANCE") {
              toast.error(errorData.ERROR_MSG);
              common.c_LogWebError(props.page, functionName, err);
            } else {
              toast.error("Failed to approve leave. Please try again.1");
              common.c_LogWebError(props.page, functionName, err);
            }
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to approve leave. Please try again.2");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  };

  // #region UseEffect
	useEffect(() => {
    let functionName = "";
    try {
      functionName = "Get Username";
      http
        .get(
          "api/leaveHistory/GetCoverBy?_sysUser=" + userId
        )
        .then((response) => {
          const userlist = [];
          for (var i = 0; i < response.data.length; i++) {
            userlist.push({
              key: response.data[i].USER_MST_GUID,
              value: response.data[i].USER_MST_GUID,
              label: response.data[i].USERNAME,
              });
          }
          setUserListToBeSelect(userlist);
        })
        .catch((err) => {
          common.c_LogWebError(props.page, functionName, err);
        });
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  }, []);

	const selectUserHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectUserHandler.name;
      if (Object.keys(val).length > 0) {
        setInputError((prevState) => ({
          ...prevState,
          USERNAME: (""),
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          USERNAME: ("Cover By could not be empty."),
        }));
      }
      setUserList([...val]);
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
    setHasChanges(true);
  }

	//#region Event handler
  const hideModal = () => {
    setEditData([]);
    setUserList([]);
    setInputError([]);
		setHasChanges(false);
    props.onHide();
  };

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
    setUserList([]);
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

  const handleConfirm = () => {
    if (userList.length === 0) {
			setInputError((prevState) => ({
				...prevState,
				USERNAME: ("Cover By could not be empty."),
			}));
      return;
		}

    if (Object.values(inputError).filter(v => v !== "").length === 0){
    	setShowConfirmModal(true);
    }
  };

  const handleConfirmModal = () => {
    SaveApproveLeave();
    setShowConfirmModal(false); // Hide confirm modal
    hideModal();
  };

  const handleConfirmModalClose = () => {
    setShowConfirmModal(false); // Hide back modal on cancel
  };
  //#endregion

	return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
            <Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Approve Leave</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
					<Comp.Select
            id="USERNAME"
            label="Cover By*"
            type="text"
            name="USERNAME"
            options={userListToBeSelect}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            errorMessage={inputError.USERNAME}
            value={userList}
            onChange={selectUserHandler}
            isMulti
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="onright-container">
            <Comp.Button
              id="btnCancel"
              type="cancel"
              onClick={handleBack}
            >
              <FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
            </Comp.Button>
                        
            <Comp.Button id="btnSave" onClick={handleConfirm}>
              <FontAwesomeIcon icon={faCheck} />&nbsp; Approve
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <BackModal
        show={showBackModal}
        onHide={handleConfirmBackCancel}
        onConfirm={handleConfirmBack}
        prop="Confirm Navigation"
      >
        Are you sure you want to go back? Your changes may be lost.
      </BackModal>

      <ConfirmModal
        show={showConfirmModal}
        onHide={handleConfirmModalClose}
        onConfirm={handleConfirmModal}
			  prop="Confirm to approve"
      >
        Are you sure you want to approve this leave?
      </ConfirmModal>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default LeaveApprove;